import { suppliesInventoryConfigIdFormat } from "@redotech/redo-ids/ids";
import { SuppliesReorderStatusSchema } from "@redotech/redo-model/supplies";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const SuppliesInventoryConfigRowSchema_ = z.object({
  id: suppliesInventoryConfigIdFormat.schema,
  productTitle: z.string(),
  productSku: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  reorderStatus: SuppliesReorderStatusSchema,
  inventoryReorderThreshold: z.number(),
  suppliesReorderQuantity: z.number(),
  locationName: z.string(),
  availableInventory: z.number(),
});

export const SuppliesInventoryConfigRowSchema: z.ZodType<SuppliesInventoryConfigRow> =
  SuppliesInventoryConfigRowSchema_;
export interface SuppliesInventoryConfigRow
  extends z.infer<typeof SuppliesInventoryConfigRowSchema_> {}

export const getSuppliesInventoryConfigs = {
  name: "getSuppliesInventoryConfigs" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
  }),
  output: z.object({ configs: z.array(SuppliesInventoryConfigRowSchema) }),
};

export const getSuppliesInventoryConfigsCount = {
  name: "getSuppliesInventoryConfigsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
};
